import { render } from "./WeekSwitcher.vue?vue&type=template&id=50887d36&ts=true"
import script from "./WeekSwitcher.vue?vue&type=script&lang=ts"
export * from "./WeekSwitcher.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__